import React from 'react';
import { useSelector } from 'react-redux';

import Table from 'components/Table';

import { GREEK } from 'staticAssets/greekCharacters';

import {
  getTableData,
  getPValue,
  getDF,
  getChiSquare,
  getN,
  getCategoricalRowDataSet
} from 'store/scenes/inferentialStatistics/selectors';

const ChiSquareGoodnessOfFit = () => {
  const tableData = useSelector(state => getTableData(state));
  const pValue = useSelector(state => getPValue(state));
  const df = useSelector(state => getDF(state));
  const chiSquare = useSelector(state => getChiSquare(state));
  const n = useSelector(state => getN(state));
  const observedCounts = useSelector(state => getCategoricalRowDataSet(state));

  const tableHeaders = [observedCounts, 'Observed Count', 'Expected Count', `Contribution to ${ GREEK.CHI}2`];
  return (
    <div className="content-item">
      <h3>Chi-Square Goodness-of-Fit</h3>
      <div>
        <span className="font-900 font-16 mr-5">H<sub>0</sub></span>
        <span>: The proportions are as proposed</span>
      </div>
      <div>
        <span className="font-900 font-16 mr-5">H<sub>A</sub></span>
        <span>: The proportions are different</span>
      </div>
      <table className="infStatMarkupChi-table mb-10 mt-10">
        <tbody>
          <tr>
            <td>n:</td>
            <td>{n}</td>
          </tr>
          <tr>
            <td>df:</td>
            <td>{df}</td>
          </tr>
          <tr>
            <td>{GREEK.CHI}<sup>2</sup> Statistic:</td>
            <td>{chiSquare}</td>
          </tr>
          <tr>
            <td>P Value:</td>
            <td>{pValue}</td>
          </tr>
        </tbody>
      </table>
      <Table
        tableHeaders={tableHeaders}
        tableData={tableData}
        alignFirstColumnLeft
        contentWidth
      />
    </div>
  );
};

export default ChiSquareGoodnessOfFit;
